import axios from 'axios';
export class HttpClient {
    success(value) {
        return {
            status: 'success',
            value,
        };
    }
    error(value) {
        return {
            status: 'error',
            value,
        };
    }
    constructor(baseURL) {
        Object.defineProperty(this, "instance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.instance = axios.create({
            baseURL,
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
        });
    }
    async get(url, params, config) {
        try {
            const response = await this.instance.get(url, { ...config, params });
            return this.success(response.data);
        }
        catch (error) {
            return this.error(error);
        }
    }
    async post(url, data, config) {
        try {
            const response = await this.instance.post(url, data, config);
            return this.success(response.data);
        }
        catch (error) {
            return this.error(error);
        }
    }
    async patch(url, data, config) {
        try {
            const response = await this.instance.patch(url, data, config);
            return this.success(response.data);
        }
        catch (error) {
            return this.error(error);
        }
    }
}
